import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/(public)/(policies)/confidentialite")({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <section className="max-container mt-10 mx-auto px-4 font-outfit">
      <h1 className="font-bold text-[#17365d] text-5xl max-md:text-2xl mb-5">
        Politique de Confidentialité de HomeToq
      </h1>
      <hr className="h-0.5 bg-dark-blue rounded-full mb-5" />

      <div>
        <h2 className="text-[#356091] font-bold text-xl">Introduction</h2>
        <p>
          La présente Politique de Confidentialité explique comment HomeToq SAS
          collecte, utilise et protège les données personnelles des Utilisateurs
          de la plateforme www.hometoq.com.
        </p>
        <br />
        <br />
      </div>

      <div>
        <h2 className="text-[#356091] font-bold text-xl">
          Responsable du traitement
        </h2>
        <p>
          <strong>Nom de la société :</strong> HomeToq SAS <br />
          <strong>Adresse du siège social :</strong> 6 Rue des Potiers, 66240
          Saint-Estève, France <br />
          <strong>Directeur de publication :</strong> M. Cameron Henri Chamorin
          (Président)
        </p>
        <br />
        <br />
      </div>

      <div>
        <h2 className="text-[#356091] font-bold text-xl">Données collectées</h2>
        <p>
          Nous collectons les types de données suivants : <br />-{" "}
          <strong>Données d&apos;identification :</strong> Nom, prénom, adresse,
          email, téléphone, etc. <br />- <strong>Données de connexion :</strong>{" "}
          Adresse IP, type de navigateur, historique de navigation, etc. <br />-{" "}
          <strong>Données de paiement :</strong> Informations bancaires
          nécessaires pour le paiement des Services.
        </p>
        <br />
        <br />
      </div>

      <div>
        <h2 className="text-[#356091] font-bold text-xl">
          Finalités du traitement
        </h2>
        <p>
          Les données personnelles collectées sont utilisées pour les finalités
          suivantes : <br />
          - Gestion des comptes Utilisateurs et des Réservations. <br />
          - Amélioration des Services et expérience utilisateur. <br />-
          Statistiques anonymes sur l&apos;utilisation de la plateforme. <br />-
          Gestion des paiements et factures.
        </p>
        <br />
        <br />
      </div>

      <div>
        <h2 className="text-[#356091] font-bold text-xl">Base juridique</h2>
        <p>
          Le traitement des données est basé sur les bases légales suivantes :{" "}
          <br />
          - Consentement de l&apos;Utilisateur. <br />
          - Exécution d&apos;un contrat (Réservations). <br />- Respect
          d&apos;une obligation légale.
        </p>
        <br />
        <br />
      </div>

      <div>
        <h2 className="text-[#356091] font-bold text-xl">
          Destinataires des données
        </h2>
        <p>
          Les données personnelles collectées peuvent être partagées avec les
          destinataires suivants : <br />
          - Les Prestataires (chefs à domicile) pour la réalisation des
          Services. <br />
          - Les prestataires techniques (hébergement, paiements) dans la limite
          nécessaire à leur intervention. <br />- Les autorités compétentes en
          cas d&apos;obligation légale.
        </p>
        <br />
        <br />
      </div>

      <div>
        <h2 className="text-[#356091] font-bold text-xl">
          Durée de conservation des données
        </h2>
        <p>
          Les données personnelles sont conservées pour une durée
          proportionnelle aux finalités du traitement : <br />
          - Données de compte : 3 ans après la dernière activité. <br />-
          Données de facturation : 10 ans selon les obligations comptables.{" "}
          <br />- Cookies : 13 mois.
        </p>
        <br />
        <br />
      </div>

      <div>
        <h2 className="text-[#356091] font-bold text-xl">
          Droits des Utilisateurs
        </h2>
        <p>
          Les Utilisateurs disposent des droits suivants : <br />
          - Droit d&apos;accès. <br />
          - Droit de rectification. <br />
          - Droit de suppression. <br />
          - Droit d&apos;opposition. <br />
          - Droit à la portabilité des données.
          <br />
          <br />
          Pour exercer ces droits, les Utilisateurs peuvent contacter notre
          délégué à la protection des données (DPO) : <br />-{" "}
          <strong>Email :</strong> contact@hometoq.com <br />-{" "}
          <strong>Adresse postale :</strong> DPO HomeToq, 6 Rue des Potiers,
          66240 Saint-Estève, France
        </p>
        <br />
        <br />
      </div>

      <div>
        <h2 className="text-[#356091] font-bold text-xl">Cookies</h2>
        <p>
          Le site www.hometoq.com utilise des cookies pour les finalités
          suivantes : <br />
          - Améliorer l&apos;expérience utilisateur. <br />
          - Collecter des statistiques anonymes de visite. <br />
          - Personnaliser les offres commerciales.
          <br />
          <br />
          L&apos;Utilisateur peut configurer son navigateur pour refuser les
          cookies.
        </p>
        <br />
        <br />
      </div>

      <div>
        <h2 className="text-[#356091] font-bold text-xl">
          Modifications de la Politique de Confidentialité
        </h2>
        <p>
          Cette politique peut être modifiée à tout moment. Les modifications
          seront publiées sur cette page avec la date de dernière mise à jour.
          <br />
          <br />
          <strong>Dernière mise à jour :</strong> 01/06/2024
        </p>
      </div>
    </section>
  );
}
